import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class DcsGhostSettlementService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following DcsGhostServiceFactory.saveGhostSettlement pattern exactly
  saveGhostSettlement(
    baseUrl: string,
    _data: any,
    Details: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Determine action code based on save_type (modalName)
    const saveType = _data?.save_type || '';
    let actionCode: string;
    let processName: string;
    
    if (saveType === 'clearTransactions') {
      actionCode = 'xj03yn'; // Action code for clear transactions
      processName = 'dcs-settlement-grid-clear';
    } else if (saveType === 'processTransactions') {
      actionCode = '1yd60j'; // Action code for process transactions
      processName = 'dcs-settlement-grid-save';
    } else {
      // Default to processTransactions if save_type is not recognized
      actionCode = '1yd60j';
      processName = 'dcs-settlement-grid-save';
    }
    
    // 🚀 CRITICAL: URL construction with action code based on modalName
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Core parameters from filterParams, globalService, or rowData
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || rowData?.SCREEN_KEY || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || rowData?.JCD_TA_KEY || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || rowData?.ACTIVITY_KEY || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || rowData?.SCREEN_TYPE || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || rowData?.IS_LOCKED || 'N';
    
    // Issue-related fields
    params.issue_id = filterParams?.issue_id || rowData?.ISSUE_ID || '';
    params.issue_short_desc = filterParams?.issue_short_desc || rowData?.ISSUE_SHORT_DESC || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || rowData?.ISSUE_ID_FOR_TX_SAVE || '';
    
    // Dynamic values from filterParams, globalService, or rowData
    params.scenarioCode = filterParams?.scenarioCode || globalService?.scenarioCode || rowData?.SCENARIO_CODE || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || rowData?.IS_ISSUE_KEY_ENABLED || 'N';
    
    // 🚀 CRITICAL: Build checkLockedbj from rowData (matching payload structure)
    const checkLockedbj: any[] = [];
    if (rowData && Object.keys(rowData).length > 0) {
      checkLockedbj.push({
        "consol_group_key": parseInt(String(rowData.CONSOL_GROUP_KEY || filterParams?.consol_group_key || '1')) || 1,
        "reporting_period": parseInt(String(rowData.REPORTING_PERIOD || filterParams?.reporting_period || '1')) || 1,
        "combination_key": parseInt(String(rowData.COMBINATION_KEY || filterParams?.combination_key || '0')) || 0,
        "scenario_key": parseInt(String(filterParams?.scenario || rowData?.SCENARIO || globalService?.scenario || '74')) || 74
      });
    } else {
      // Fallback if rowData is not available
      checkLockedbj.push({
        "consol_group_key": parseInt(String(filterParams?.consol_group_key || '1')) || 1,
        "reporting_period": parseInt(String(filterParams?.reporting_period || '1')) || 1,
        "combination_key": parseInt(String(filterParams?.combination_key || '0')) || 0,
        "scenario_key": parseInt(String(filterParams?.scenario || globalService?.scenario || '74')) || 74
      });
    }
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Additional required fields
    params.filing_key = filterParams?.filing_key || rowData?.CONSOL_GROUP_KEY || filterParams?.consol_group_key || '1';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || rowData?.PARENT_ME_STRING || '';
    
    // Add save_type to params exactly like AngularJS
    params.save_type = saveType;
    
    // Set process_name based on action code
    params.process_name = processName;

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // Matches legacy updateGhostSettlementFactory.updateGhostSettlement (action_code=gioank)
  updateGhostSettlement(
    baseUrl: string,
    _data: any,
    Details: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=gioank`;

    const colMap = _data?.colData?.map || _data?.col_id || '';
    const params: any = {
      filing_key: rowData?.FILING_GROUP || '',
      column_value: rowData?.[colMap] || '',
      column_name: colMap,
      tax_year: rowData?.TAX_YEAR || filterParams?.tax_year || '',
      scenario: rowData?.SCENARIO || filterParams?.scenario || '',
      clob_data: JSON.stringify(rowData || {})
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

